import { Button, Flex, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import UTMLink from "@components/UTMLink";
import React from "react";

type YieldBridgeProps = {
  heading: string;
  chains?: { chain: string; icon: string }[];
  bridgeURL: string;
  isExternal?: boolean;
};

const YieldBridge = ({
  heading,
  chains = [],
  bridgeURL,
  isExternal = false,
}: YieldBridgeProps) => {
  return (
    <Flex direction={"column"} p="16px" gap="16px">
      <Text fontSize={"16px"} fontWeight={"600"} lineHeight={"24px"}>
        {heading}
      </Text>
      {chains.length > 0 && (
        <Flex gap="10px" wrap={"wrap"}>
          {chains.map((c, index) => {
            return (
              <Flex
                key={`faq_${index}`}
                border="1px solid #638E8E"
                borderRadius={"32px"}
                p={"1px 6px 2px 4px"}
                gap="4px"
              >
                <BaseImage
                  src={c.icon}
                  alt="swap"
                  height={16}
                  width={16}
                  loading="eager"
                  style={{ borderRadius: "50%" }}
                />
                <Text fontWeight="500" fontSize="14px" pt="1px">
                  {c.chain}
                </Text>
              </Flex>
            );
          })}
        </Flex>
      )}
      <UTMLink
        href={bridgeURL}
        _hover={{
          borderBottom: "none",
        }}
        isExternal={isExternal}
      >
        <Button
          borderRadius="12px"
          bg="textPrimary"
          p="8px 16px"
          h="48px"
          mt={"20px"}
          width={{ base: "100%", sm: "200px" }}
          _hover={{
            bg: "textPrimary",
          }}
          gap={"10px"}
        >
          <Text
            fontSize="16px"
            lineHeight="19.2px"
            fontWeight="600"
            color="backgroundCard"
          >
            Go To Bridge{" "}
          </Text>
          <BaseImage src={"/assets/bridge.svg"} alt="" width={20} height={20} />
        </Button>
      </UTMLink>
    </Flex>
  );
};

export default YieldBridge;
